
import { Component } from '@angular/core';
import { SimulatorType } from '../../../../core/enums/simulator-type.enum';
import { SimulatorConfig } from '../../../../core/models/simulation.model';
import { BasicUpscalingSimulatorComponent } from '../../../../common/basic-upscaling-simulator/basic-upscaling-simulator.component';

@Component({
  selector: 'app-upscaling-formation-factor',
  imports: [BasicUpscalingSimulatorComponent],
  standalone: true,
  templateUrl: './formation-factor.component.html',
  styleUrl: './formation-factor.component.scss',
})
export class UpscalingFormationFactorComponent {
  readonly config: SimulatorConfig = {
    title: 'Upscaling - Formation Factor Simulation',
    simulatorType: SimulatorType.UpscalingFF,
  };
}
